module.exports = "<div [id]=\"chartID\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.html
// module id = ./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.html
// module chunks = 0